/**
 * navZones — las 5 zonas del Portal (Hoy · Trabajo · Plan · Resultados ·
 * Cuenta), fuente única para el Sidebar de escritorio, la barra inferior
 * móvil y el rótulo de zona de la barra superior.
 *
 * SOA 10 PRO · bug 10: la barra inferior no marcaba la pestaña activa porque
 * cada NavTab era un <Link> sin estado. Acá `isActive(pathname)` resuelve la
 * zona por prefijo de ruta (incluye las rutas legadas que redirigen), de modo
 * que /cuenta/equipo sigue marcando "Cuenta" aunque el destino del ítem sea
 * /cuenta/brand.
 */
export const ZONAS = [
  { key: "hoy",        to: "/",             label: "Hoy",        icon: "home",           prefetch: "dashboard",
    isActive: (p) => p === "/" },
  { key: "trabajo",    to: "/tareas",       label: "Trabajo",    icon: "checklist",      prefetch: "tareas",   tour: "nav-trabajo",
    isActive: (p) => p.startsWith("/tareas") || p.startsWith("/pedidos") || p.startsWith("/campanas") || p.startsWith("/favoritos") || p.startsWith("/aprobar") },
  { key: "plan",       to: "/planes",       label: "Plan",       icon: "calendar_month", prefetch: "planes",   tour: "nav-plan",
    isActive: (p) => p.startsWith("/planes") || p.startsWith("/calendario") || p.startsWith("/feed-preview") },
  { key: "resultados", to: "/reportes",     label: "Resultados", icon: "bar_chart",      prefetch: "reportes", tour: "nav-resultados",
    isActive: (p) => p.startsWith("/reportes") || p.startsWith("/galeria") },
  { key: "cuenta",     to: "/cuenta/brand", label: "Cuenta",     icon: "settings",       prefetch: "brand",
    isActive: (p) => p.startsWith("/cuenta") || ["/brand", "/documentos", "/equipo", "/facturas", "/configuracion"].some(r => p.startsWith(r)) },
];

/** Rótulo de la zona activa para la barra superior ("Hoy", "Trabajo"…). */
export function zonaDeRuta(pathname) {
  const z = ZONAS.find(z => z.isActive(pathname));
  if (z) return z.label;
  if (pathname.startsWith("/chat")) return "Conversación";
  return null;
}
